// extracted by mini-css-extract-plugin
export var container = "Photo-module--container--26682";
export var cover = "Photo-module--cover--5ea77";
export var fadeIn = "Photo-module--fadeIn--f7d0a";
export var loading = "Photo-module--loading--544d3";